import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import LeadProfileInfo from "../fully-customised/LeadProfileInfo";
import AllFollowupInfo from "../fully-customised/AllFollowupInfo";
import { fetchApiDataDup3 } from "../../../redux/reducers/commonApiSlice";
import { addLeadFollowup } from "../../../data/ApiEndpoints";
import FollowupSystemMobile from "../fully-customised/FollowupSystemMobile";
// import FollowupTbDesktop from "./FollowupTbDesktop";
// import BackAddBtns from "../../Open-pages/target-matrics/common/BackAddBtns";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ManageLeadForm from "./ManageLeadForm";
import FollowInfoFormV1 from "./FollowInfoFormV1";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import AllLeadsFollowupDetails from "./AllLeadsFollowupDetails";
import FollowupDesktop from "../lms-v2/lms-followups/FollowupDesktop";

const LeadFollowupV1 = ({
  userInfoData,
  rowData,
  callFunction,
  closeFollowupModal,
  isAllLeadDetails,
  pageName,
  prevFilters,
}) => {
  const dispatch = useDispatch();
  const { dataDup3, loadingDup3 } = useSelector((state) => state.common);

  const isMarketing = userInfoData?.account_type === "marketing";
  const isAdmin = userInfoData?.account_type === "admin";

  const [rowDataState, setRowDataState] = useState(rowData || null);
  const [allFollowupsDatas, setAllFollowupsDatas] = useState([]);
  const initialModelValues = {
    isModOpen: false,
    cardName: "",
    indexRow: "",
    leadId: "",
    remarks: "",
  };
  const [allModels, setAllModel] = useState(initialModelValues);

  const isClosed =
    rowDataState?.lead_status === "closed" ||
    rowDataState?.lead_status === "converted";

  const sortedFollowupData =
    allFollowupsDatas?.length > 0
      ? [...allFollowupsDatas].sort(
          (a, b) => b?.follow_up_number - a?.follow_up_number
        )
      : [];

  function onCloseModal() {
    setAllModel(initialModelValues);
  }

  function getLeadFollowup() {
    const filters = {
      lead_id: rowDataState.lead_id,
    };

    dispatch(
      fetchApiDataDup3({
        method: "GET",
        endpoint: addLeadFollowup,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (rowDataState?.lead_id) {
      getLeadFollowup();
    }
  }, [rowDataState.lead_id]);

  useEffect(() => {
    if (dataDup3?.status && dataDup3?.data && !loadingDup3) {
      setAllFollowupsDatas(dataDup3.data);
    } else {
      setAllFollowupsDatas([]);
    }
  }, [dataDup3]);

  return (
    <>
      <Modal
        isOpen={allModels.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer add-new-lead-form ${
            allModels.cardName === "follow-up-date" ||
            allModels.cardName === "manage-lead"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              allModels.cardName === "follow-up-date"
                ? "Followup Date/Time and Description"
                : allModels.cardName === "manage-lead"
                ? "Manage Lead"
                : ""
            }`}
            onClose={onCloseModal}
          />

          {allModels.cardName === "follow-up-date" ? (
            <FollowInfoFormV1
              userInfoData={userInfoData}
              rowData={rowDataState}
              followupStage={sortedFollowupData?.[0]?.follow_up_number || 0}
              callFunction={callFunction}
              allFollowups={allFollowupsDatas}
              closeModal={() => {
                onCloseModal();
                closeFollowupModal();
              }}
            />
          ) : allModels.cardName === "manage-lead" ? (
            <ManageLeadForm
              userInfoData={userInfoData}
              rowData={rowDataState}
              callFunction={() => {
                getLeadFollowup();
                callFunction();
              }}
              closeModal={onCloseModal}
              followupStage={sortedFollowupData?.[0]?.follow_up_number || 0}
            />
          ) : null}
        </div>
      </Modal>

      {/* {!isClosed ? (
        <div className="manage-followup-buttons only-desktop">
          <BackAddBtns
            addBtnTxt={"Create New Followup"}
            addBtnTxt1={isAdmin ? "Manage Lead" : null}
            onClickAdd={() =>
              setAllModel((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "follow-up-date",
              }))
            }
            onClickAdd1={() =>
              isAdmin &&
              setAllModel((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "manage-lead",
              }))
            }
            onClickReload={() => {
              getLeadFollowup();
            }}
            isAddBtn={!isMarketing ? true : false}
          />
        </div>
      ) : null} */}

      {isAllLeadDetails && (
        <AllLeadsFollowupDetails
          userInfoData={userInfoData}
          pageName={pageName}
          rowDataState={rowDataState}
          setRowDataState={setRowDataState}
          prevFilters={prevFilters}
        />
      )}

      {loadingDup3 ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="followup-management-container mt30">
          <div className="followup-box left-part lead-info">
            <LeadProfileInfo rowData={rowDataState} />
            <AllFollowupInfo rowData={rowDataState} />
          </div>
          <div className="followup-box right-part manage-followup">
            <div className="only-desktop">
              <FollowupDesktop
                allFollowups={sortedFollowupData || []}
                addFollowup={() =>
                  setAllModel((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "follow-up-date",
                  }))
                }
                leadStatus={rowData?.lead_status}
              />
              {/* <FollowupTbDesktop
                userInfoData={userInfoData}
                allFollowups={sortedFollowupData || []}
                addFollowup={() =>
                  setAllModel((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "follow-up-date",
                  }))
                }
                leadStatus={rowDataState?.lead_status}
              /> */}
            </div>

            <div className="mobile-version-followup">
              <FollowupSystemMobile
                userInfoData={userInfoData}
                rowData={rowDataState}
                allFollowups={sortedFollowupData || []}
                callFunction={() => {
                  getLeadFollowup();
                  callFunction();
                }}
                isMarketing={isMarketing}
                isAdmin={isAdmin}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadFollowupV1;
